import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { getAdminToken, getAdminRole } from './Common'

const AdminPublicRoute = () => {
    const isLoggedIn = getAdminToken()
    const adminRole = getAdminRole()

    if (isLoggedIn) {
        return <Navigate to={(adminRole==='challan' || adminRole==='challan-limited' || getAdminRole()==='challan-vendor') ? "/admin/challan-payments" : "/admin/dashboard"} replace />
    }

    return <Outlet />
}

export default AdminPublicRoute